export default {
  namespaced: true,
  state: {
    access_token: null,
    refresh_token: null,
  },
}